import * as React from 'react';

import cn from 'classnames';

import { ILabelProps } from './types';

import * as s from './Label.scss';

export const Label = ({ className, text, id, children }: ILabelProps) => {
	return text || children
		? <label htmlFor={id} className={cn(s.label, className)}>{text || children}</label>
		: null;
};
